export default __webpack_public_path__ + "static/media/7.23e680c7.png";